type Guard = (resume: () => void) => boolean;
let current: Guard | null = null;
let bypass = 0;
/** Opt-in only: the existing router behaves identically without a registrant. */
export function registerNavigationGuard(guard: Guard): () => void {
  current = guard;
  return () => { if (current === guard) current = null; };
}
export function navigationGuarded(resume: () => void): boolean {
  return bypass === 0 && !!current?.(resume);
}
export function resumeNavigation(action: () => void): void {
  bypass++;
  try { action(); } finally { bypass--; }
}
/** True while a screen has registered a guard (an open form with unsaved changes). Read by the
 *  expired-session handler to say "your changes were not saved" (CC 0176). */
export function navigationGuardActive(): boolean { return current !== null; }

/**
 * Routes whose screen is a form a person types into (CC 0336). When the session ends on one of these,
 * the screen stays mounted under the sign-in dialog whether or not it registered a guard, so an
 * editor never loses typed work to an expired session. Matched by route id, so a new editor route
 * named in the usual way (".edit", ".editor", the creation steps) is covered without registering.
 */
const FORM_ROUTE = /(^|\.)(edit|editor)$|^create(\.|$)|^hub\.create\.|^messaging\.(flow|compose|compose\.email|builder)$/;
export function isFormRoute(route: string | null | undefined): boolean { return !!route && FORM_ROUTE.test(route); }
